/** @deprecated use 'redux/types/state.interface/status' */
export enum Status {
  IDLE = 'idle',
  IN_PROGRESS = 'in_progress',
  ERROR = 'error',
  SUCCESS = 'success',
}
